// C Programming Course
import {
    session1, session2, session3, session4, session5,
    session6, session7, session8, session9, session10
} from './sessions.js';

export const cProgramming = {
    id: "c-programming",
    title: "C Programming",
    description: "Master C programming from fundamentals to advanced topics including pointers, memory management, and file I/O",
    color: "#00599C",
    icon: "💻",
    level: "Beginner to Intermediate",
    duration: "10 hours",
    students: "2,500",
    sessions: [
        session1,   // Introduction to C Programming
        session2,   // Variables, Data Types, and Operators
        session3,   // Control Flow (if, switch, loops)
        session4,   // Functions and Scope
        session5,   // Arrays and Strings
        session6,   // Pointers Fundamentals
        session7,   // Structures and Unions
        session8,   // File I/O
        session9,   // Dynamic Memory Allocation
        session10   // Advanced Topics and Best Practices
    ]
};
